import { Component, OnInit, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { matchingPasswords, emailValidator } from '../../theme/utils/app-validators';
import { AuthSandbox } from '../../../core/auth/auth.sandbox';
import { CommonSandbox } from '../../../core/common/common.sandbox';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../core/common/common.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import moment from 'moment-timezone';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from '../../shared/ngx-intl-tel-input/src/public_api';
import { take } from 'rxjs/operators';
@Component({
	selector: 'app-vendor-reg',
	templateUrl: './vendor-reg.component.html',
	styleUrls: ['./vendor-reg.component.scss']
})
export class VendorRegComponent implements OnInit {

	public registerForm: FormGroup;
	public submitted = false;
	public countries = [];
	public services = [];
	public activeService = 0;
	public selectedService: any;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [
		CountryISO.UnitedStates,
		CountryISO.UnitedKingdom,
	];

	public config: SwiperConfigInterface = {};

	public slides: Promise<any>;

	constructor(public formBuilder: FormBuilder, public authSandbox: AuthSandbox, public commonSandbox: CommonSandbox,
		private toastr: ToastrService,
		private commonService: CommonService,
		private route: ActivatedRoute,
		private el: ElementRef,
		private router: Router
	) { }

	ngOnInit() {

		this.userServices();
		const mobileValidationPattern = '^-?[0-9]\\d*(\\.\\d{1,2})?$';
		const nameValidationPattern = '[a-zA-Z \'-,;.]*';


		this.registerForm = this.formBuilder.group({
			'fName': ['', Validators.compose([Validators.required, Validators.pattern(nameValidationPattern), Validators.minLength(3)])],
			'lName': ['', Validators.compose([Validators.required, Validators.pattern(nameValidationPattern)])],
			'email': ['', Validators.compose([Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])],
			'password': ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])((?=.*?[0-9])|(?=.*?[#?!@$%^&*-])).{8,}$')])],
			'confirmPassword': ['', Validators.compose([Validators.required])],
			'phoneNumber': ['', Validators.compose([Validators.required])],
			'categoryId': [''],
			//'shippingPolicy': ['', Validators.compose([Validators.required])],
			'service_id': ['', Validators.compose([Validators.required])],
			//'typeOfBusiness': ['', Validators.compose([Validators.required])],
			//'productsMadeOf': ['', Validators.compose([Validators.required])],
			//'howLongInBusiness': ['', Validators.compose([Validators.required])],
			'companyName': [''],
			'companyDescription': [''],
			//'haveAWebsite': ['', Validators.compose([Validators.required])],
			//'whyJoin': ['', Validators.compose([Validators.required])],
			'companyCountryId': [''],
			'referralCode': ['']
		}, { validator: matchingPasswords('password', 'confirmPassword') });
		this.getCategoryList();
		this.commonService.getCounty({}).toPromise().then((response: any) => {
			this.countries = response.data;
		});
		$('.sign-btn').on('click', function () {
			if ($('.error')) {
				$('html, body').animate({
					'scrollTop': $('.error').position()['top']
				});
			}
		});


		this.route.queryParams.subscribe(data => {

			if (data?.service_id) {
				this.activeService = data?.service_id;
				this.registerForm.controls['service_id'].setValue(this.activeService);
			}
			if (data?.email) {
				this.registerForm.controls['email'].setValue(data?.email);
			}
		});



		this.slides = new Promise((resolve, reject) => {
			setTimeout(() => {
				return resolve([

					{
						title: "Reach shoppers around the world instantly",
						image: "assets/img/why-1.png",
					},
					{
						title: "Liaise directly with your customers on the Social Hub",
						image: "assets/img/why-2.png",
					},
					{
						title: "Manage your own special offers and reward schemes",
						image: "assets/img/why-3.png",
					},
					{
						title: "Stand out with a customisable shop front",
						image: "assets/img/why-4.png",
					},
					{
						title: "Just 1 low cost monthly fee. No set up fees or commissions",
						image: "assets/img/why-5.png",
					},
					{
						title: "Quick and easy invoicing, shipping and refunds from the dashboard",
						image: "assets/img/why-6.png",
					},

				])
			}, 500)
		})
	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateAllFormFields(control);
			}
		});
	}

	userServices() {
		const params: any = {};

		params.limit = 10;
		params.offset = 0;

		this.commonService.getServicesForUsers(params).toPromise().then(response => {
			console.log("response");
			this.services = response.data;
			if (this.activeService) {
				const service = response.data.find(item => item.serviceId == this.activeService);
				if (service) {
					this.selectService(service);
				}
			}
			console.log(response);
		});
	}

	selectService(service) {
		console.log("id of service", service.serviceId);
		this.registerForm.controls['service_id'].setValue(service.serviceId);
		this.activeService = service.serviceId;
		this.selectedService = service;
	}

	get companyCountryId() {
		return this.registerForm.get('companyCountryId');
	}

	get categoryId() {
		return this.registerForm.get('categoryId');
	}

	public getCategoryList(): void {
		this.commonSandbox.getCategories({});
	}

	public changeCountry(e) {
		console.log(" *****  e.target.value", e);
	}

	public changeCategory(e) {
		console.log(" *****  e.target.value", e);
	}

	public onRegisterFormSubmit(values: Object): void {
		this.submitted = true;
		;

		if (this.registerForm.valid) {
			const params = this.registerForm.value;

			console.log("register values");
			console.log(params);
			console.log(" **** params.phoneNumber ", params.phoneNumber);
			params.phoneNumber = params.phoneNumber.e164Number;
			this.authSandbox.doRegister(params);

			this.authSandbox.vendorId$.pipe(take(2)).subscribe(registerLoaded => {
				console.log("registerLoaded", registerLoaded);
				if (registerLoaded) {
					if (this.selectedService.price == 0) {
						let data: any = {};
						data.serviceId = this.selectedService.serviceId;
						data.serviceName = this.selectedService.title;
						data.price = this.selectedService.price;
						data.vendorId = registerLoaded;
						this.commonService.saveVendorPayment(data).toPromise().then(response => {
							this.toastr.success('Thank you for signing up with premierstreets.com, your account is up and running, happy stay.', 'Success');
							this.router.navigate(['auth/login']);
						});
					} else {
						this.router.navigate(['auth/vendor-payment'], { queryParams: { id: this.activeService, uid: registerLoaded, type: 0 } });
					}
					//return false;
					//					this.toastr.success('You have been registered successfully, Your application is under review.', 'Success');
				}
			})

			// this.authSandbox.registerFailed$.pipe(take(2)).subscribe(registerFailed => {
			// 	if(registerFailed){
			// 		this.toastr.error("Something went wrong", 'Error');
			// 	}
			// })

		} else {
			console.log('else');
			this.validateAllFormFields(this.registerForm);
			const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
				"form .ng-invalid"
			);

			if (firstInvalidControl) {
				firstInvalidControl.focus();
			}

		}
	}



	ngAfterViewInit() {

		this.config = {
			observer: true,
			slidesPerView: 3,
			spaceBetween: 30,
			loop: false,
			keyboard: true,
			navigation: true,
			pagination: false,
			grabCursor: false,
			autoplay: false,
			speed: 900,
			allowTouchMove: false,
			effect: 'slide',
			breakpoints: {
				730: {
					slidesPerView: 1,
					allowTouchMove: true,
					grabCursor: false,

					spaceBetween: 20,
				},


			}
		};
	}
}
